export class User {
  id: string;
  firstName: string;
  middleName: string;
  lastName: string;
  fullName: string;
  primaryMobileNumber: string;
  primaryEMail: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/user.model.ts